
import { all, fork, spawn } from "redux-saga/effects";
import todoSaga from "./todo/sagas";
import dashboardSaga from '../Pages/StashKar/Dashboard/sagadashboard';
import sagaLogin from "../Pages/StashKar/Auth/Login/sagaLogin";
import legalSaga from "../Pages/StashKar/LegalAuth/sagaLegal";
import sagaPersonalInfo from "../Pages/StashKar/PersonalInfo/sagaPersonalInfo";
import sagaConnectBank from "../Pages/StashKar/ConnectBank/sagaConnectBank";
import sagaManualKyc from "../Pages/StashKar/ManualKycLink/sagaManualKyc";
import sagaAdharCard from "../Pages/StashKar/AdharCardKyc/sagaAdharCard";
import sagaInvestFund from "../Pages/StashKar/InvestFund/sagaInvestFund";
import lenderSaga from "../Pages/StashKar/LenderAgreement/laSaga";
import faqSaga from "../Pages/StashKar/FaqHelp/faqSaga";
export function* rootSaga() {
  yield all(
    [
      fork(todoSaga),
      spawn(sagaLogin),
      fork(dashboardSaga),
      spawn(legalSaga),
      spawn(sagaPersonalInfo),
      spawn(sagaConnectBank),
      spawn(sagaManualKyc),
      spawn(sagaAdharCard),
      spawn(sagaInvestFund),
      spawn(lenderSaga),
      spawn(faqSaga)
    ]
  );
}